// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let PageUITitle = require("../../components/PageTitle/PageUITitle.bs.js");
let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let ErrorComponent = require("../../reason/common/Error/ErrorComponent.bs.js");
let ContentBox__Jsx3 = require("../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let HighlightSection__Jsx3 = require("../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
let ChapterMembersListRelay = require("./ChapterMembersListRelay.bs.js");
let ChapterMembersListRelayQueryParams = require("./ChapterMembersListRelayQueryParams.bs.js");
let ChapterMembersPageRelayQuery_graphql = require("../../__generated__/ChapterMembersPageRelayQuery_graphql.bs.js");

let convertVariables = ChapterMembersPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = ChapterMembersPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ChapterMembersPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ChapterMembersPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ChapterMembersPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ChapterMembersPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(ChapterMembersPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ChapterMembersPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ChapterMembersPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let error = JsxRuntime.jsx(ErrorComponent.make, {
  message: "We encountered a problem while getting membership data. Please refresh or try again later."
});

function ChapterMembersPageRelay$Page(props) {
  let match = ChapterMembersListRelayQueryParams.use();
  let queryParams = match[0];
  let match$1 = React.useState(() => queryParams);
  let initialQueryParams = match$1[0];
  let data = use({
    after: initialQueryParams.after,
    before: initialQueryParams.before,
    search: initialQueryParams.search
  }, undefined, undefined, undefined);
  let match$2 = data.currentChapterV5;
  if (match$2 === undefined) {
    return error;
  }
  let memberCount = match$2.memberCount;
  let brokerageCount = match$2.brokerageCount;
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsxs(ContentBox__Jsx3.make, {
      paddingFull: true,
      hasShadow: true,
      children: [
        JsxRuntime.jsx(PageUITitle.make, {
          title: "Member Directory"
        }),
        memberCount !== undefined && brokerageCount !== undefined ? JsxRuntime.jsx(HighlightSection__Jsx3.make, {
            background: "Muted",
            children: `There are ` + memberCount.toString() + ` top agent members in TAN ` + match$2.displayName + `. These agents represent ` + brokerageCount.toString() + ` different brokerages.`
          }) : JsxRuntime.jsx(HighlightSection__Jsx3.make, {
            background: "Danger",
            children: "We encountered a problem while getting membership stats for this chapter... Please refresh or try again later."
          }),
        JsxRuntime.jsx(ChapterMembersListRelay.make, {
          chapter: match$2.fragmentRefs
        })
      ]
    })
  });
}

let Page = {
  make: ChapterMembersPageRelay$Page
};

function ChapterMembersPageRelay(props) {
  return JsxRuntime.jsxs(React.Suspense, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Member Directory"
      }),
      JsxRuntime.jsx(ChapterMembersPageRelay$Page, {})
    ],
    fallback: JsxRuntime.jsx(Loader.make, {})
  });
}

let make = ChapterMembersPageRelay;

let $$default = ChapterMembersPageRelay;

exports.Query = Query;
exports.error = error;
exports.Page = Page;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
